import StackAPI from '@/lib/StackAPI'
import Storage from '@/lib/Storage'
import { isEmpty } from '@/utils/isEmpty'
import { captureException } from '@sentry/react'
import { GetListParams } from 'react-admin'

const PATH = '/partners/vendor/batches'

const getVendorBatches = async (params: GetListParams) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { get } = StackAPI()
  const { filter, pagination } = params

  return await get({
    path: PATH,
    params: {
      page: pagination?.page,
      per_page: pagination?.perPage,
      start_at: filter?.startAt,
      end_at: filter?.endAt,
      order_view: filter?.orderView
    }
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      captureException(error, { extra: { role } })
      return { error: 'unknown error' }
    })
}

export default getVendorBatches
